import { env } from 'config';
import { P2PProviderRequest, QueryParams } from 'types';
import { apiUtils } from 'utils';

const url = `${env.apiUrl}/p2p-providers-payin-requests`;

export const p2pProvidersPayinRequestsApi = {
  getForOrder:
    (orderId: string) =>
    async (params?: Partial<QueryParams>): Promise<P2PProviderRequest[]> =>
      (await apiUtils.getWithQueryParams(`${url}/order/${orderId}`, params))
        .data,

  pollStatus: apiUtils.withAxiosInstance<{ orderId: string }, void>(
    async (axiosInstance, { orderId }) =>
      (await axiosInstance.post(`${url}/order/${orderId}/poll-status`)).data,
  ),
};
